import { UIState } from "@hydra/core/uiState";
import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class HeroSearcher implements Plugin {
  private unsubscribeCurrentBreakpoint?: () => void;

  private heroSearcherMobile: HTMLImageElement;
  private heroSearcherDesktop: HTMLImageElement;

  constructor(private element: HTMLElement) {
    this.heroSearcherMobile = this.element.querySelector(
      ".dsc-co-heroSearcher__mobile",
    ) as HTMLImageElement;

    this.heroSearcherDesktop = this.element.querySelector(
      ".dsc-co-heroSearcher__desktop",
    ) as HTMLImageElement;

    const uiState = UIState.getInstance();
    this.unsubscribeCurrentBreakpoint = uiState.subscribe(
      "currentBreakpoint",
      () => this.showHeroSearcher(uiState),
    );
    this.showHeroSearcher(uiState);
  }

  init(): void {}

  private showHeroSearcher(uiState: UIState): void {
    const isSmallDevice = uiState.isMobile || uiState.isTablet;
    this.heroSearcherMobile?.classList.toggle("hidden", !isSmallDevice);
    this.heroSearcherDesktop?.classList.toggle("hidden", isSmallDevice);
  }
}

PluginRegistry.register("hero-searcher", HeroSearcher);
